import { useState } from 'react'
import { Typography } from 'components/Contentful'
import Info from 'components/Svgs/Info'
import { X } from 'react-feather'
import { Button, Dialog, DialogTitle, DialogContent, IconButton, Slider } from '@achieve/ascend'
import { dollarUSLocale, roundDownToNearestThousand } from './utils'

function AmountSlider({
  jsonConfig,
  modalStatus,
  setModalStatus,
  debouncedSliderAmount,
  sliderAmountConfig,
  helocUpdated,
  handleReleaseAmount,
}) {
  const [displayAmount, setDisplayAmount] = useState(
    roundDownToNearestThousand(
      debouncedSliderAmount || sliderAmountConfig.min,
      sliderAmountConfig.max
    )
  )

  function handleChangeAmount(e) {
    setDisplayAmount(roundDownToNearestThousand(e.target.value, sliderAmountConfig.max))
  }

  return (
    <>
      <div>
        <Typography
          content={jsonConfig?.amountTitle || 'Desired loan amount'}
          variant="bodyLg"
          mobileVariant="bodySm"
          responsive={true}
          data-testid="heloc-amount-title"
          className="contents text-[#42546B]"
        />
        {jsonConfig?.amountInfo && (
          <>
            <IconButton
              onClick={() => {
                setModalStatus(true)
              }}
            >
              <Info className="pb-2" />
            </IconButton>

            <Dialog
              open={modalStatus}
              onClose={() => {
                setModalStatus(false)
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogContent>
                <DialogTitle id="alert-dialog-title" className="flex justify-end py-4">
                  <IconButton
                    onClick={() => {
                      setModalStatus(false)
                    }}
                  >
                    <X />
                  </IconButton>
                </DialogTitle>
                <Typography variant="bodyMd" content={jsonConfig?.amountInfo} />

                <Button
                  onClick={() => {
                    setModalStatus(false)
                  }}
                  className="w-full my-4"
                  color="secondary"
                  variant="contained"
                >
                  Got it
                </Button>
              </DialogContent>
            </Dialog>
          </>
        )}
      </div>
      <Typography
        content={`$${dollarUSLocale.format(displayAmount)}${
          displayAmount === sliderAmountConfig.max && sliderAmountConfig.maxPlus ? '+' : ''
        }`}
        variant="headingMd"
        fontWeight="bold"
        className="py-2"
      />
      <Slider
        aria-label="dollar-amount-selection-slider"
        classes={{
          mark: 'hidden',
        }}
        data-testid="heloc-term-slider-amount"
        value={displayAmount}
        step={sliderAmountConfig.step}
        min={sliderAmountConfig.min}
        max={sliderAmountConfig.max}
        marks={[
          {
            value: sliderAmountConfig.min,
            label: (
              <Typography
                content={`$${dollarUSLocale.format(sliderAmountConfig.min)}`}
                variant="bodySm"
                fontWeight="regular"
                className={'translate-x-6 text-[#5C708A]'}
              />
            ),
          },
          {
            value: sliderAmountConfig.max,
            label: (
              <>
                <Typography
                  content={`$${dollarUSLocale.format(sliderAmountConfig.max)}${
                    sliderAmountConfig.maxPlus ? '+' : ''
                  }`}
                  variant="bodySm"
                  fontWeight="regular"
                  className={`${
                    helocUpdated
                      ? '-translate-x-7 text-[#5C708A] text-right'
                      : '-translate-x-16 text-[#5C708A] text-right'
                  }`}
                />
                {helocUpdated ? null : (
                  <Typography
                    content="Max loan amount"
                    variant="bodySm"
                    fontWeight="regular"
                    className={'-translate-x-16 text-[#C0CBD8]'}
                  />
                )}
              </>
            ),
          },
        ]}
        onChange={(e) => {
          handleChangeAmount(e)
          if (e.target.value === sliderAmountConfig.max) {
            handleReleaseAmount(sliderAmountConfig.max)
          }
          if (e.target.value === sliderAmountConfig.min) {
            handleReleaseAmount(sliderAmountConfig.min)
          }
        }}
        onMouseUp={() => {
          handleReleaseAmount(displayAmount)
        }}
        onTouchEnd={() => {
          handleReleaseAmount(displayAmount)
        }}
      />
    </>
  )
}

export { AmountSlider }
